// src/utils/reporteCreditosGenerator.js

// 👈 NUEVO: Importar función que obtiene los datos de la empresa actual
import { obtenerDatosEmpresa } from './tenantConfig';

// Configuración por defecto (fallback)
const JEAN_INFORMATICO_CONFIG = {
  nombre: 'JEAN INFORMATICO C.A.',
  rif: 'J-41023119-0',
  slogan: 'Soluciones Tecnológicas',
  direccion: 'CALLE 30, CON AV. 33, C.C LATIN CENTER, LOCAL 01',
  ciudad: 'ACARIGUA, EDO. PORTUGUESA',
  telefono: '04145146450 / 5516151 / 02556223297',
  email: 'JEANINFORMATICOCA@GMAIL.COM',
  sitioWeb: 'www.jeaninformatico.com.ve'
};

/**
 * 👈 NUEVO: Obtiene la config de la empresa actual con fallback
 */
const getEmpresa = () => {
  try {
    const datos = obtenerDatosEmpresa();
    return {
      nombre: datos.nombreComercial || datos.nombre || JEAN_INFORMATICO_CONFIG.nombre,
      rif: datos.rif || JEAN_INFORMATICO_CONFIG.rif,
      slogan: datos.slogan || JEAN_INFORMATICO_CONFIG.slogan,
      direccion: datos.direccion || JEAN_INFORMATICO_CONFIG.direccion,
      ciudad: datos.ciudad || JEAN_INFORMATICO_CONFIG.ciudad,
      telefono: datos.telefono1 || datos.telefono2 || JEAN_INFORMATICO_CONFIG.telefono,
      email: datos.email || JEAN_INFORMATICO_CONFIG.email,
      sitioWeb: datos.sitioWeb || JEAN_INFORMATICO_CONFIG.sitioWeb,
      logoBase64: datos.logoBase64 || null,
    };
  } catch (err) {
    console.warn('⚠️ No se pudo obtener config del tenant, usando fallback:', err);
    return { ...JEAN_INFORMATICO_CONFIG, logoBase64: null };
  }
};

// ============================================================
// UTILIDADES LOCALES (antes venían de reporteProductosGenerator)
// ============================================================

const formatearFechaReporte = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return fechaISO;
  }
};

const formatearFechaCorta = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return fechaISO;
  }
};

const formatearNumero = (valor, decimales = 2) => {
  if (valor === null || valor === undefined || isNaN(valor)) return '0,00';
  return Number(valor).toFixed(decimales).replace('.', ',');
};

const formatearMonedaUSD = (valor) => {
  if (valor === null || valor === undefined || isNaN(valor)) return '$ 0,00';
  return `$ ${formatearNumero(valor)}`;
};

// ============================================================
// REPORTE PRINCIPAL DE CRÉDITOS
// ============================================================

export const generarHTMLReporteCreditos = (datos, estadisticas) => {
  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant
  const fechaActual = new Date();
  
  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Reporte de Créditos - ${empresa.nombre}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: 'Arial', 'Helvetica', sans-serif;
          background: white;
          padding: 20px;
          color: #333;
        }
        .reporte { max-width: 1000px; margin: 0 auto; }
        
        /* Header */
        .header {
          padding: 15px 0;
          border-bottom: 2px solid #333;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .logo-area { display: flex; align-items: center; gap: 15px; }
        .logo-img { height: 60px; width: auto; object-fit: contain; }
        .empresa-nombre { font-size: 20px; font-weight: bold; color: #000; }
        .empresa-slogan { font-size: 12px; color: #666; }
        .rif-info { text-align: right; font-size: 11px; line-height: 1.4; color: #444; }
        
        /* Título */
        .titulo-seccion {
          margin-bottom: 25px;
          text-align: center;
        }
        .titulo-seccion h1 { 
          font-size: 22px; 
          text-transform: uppercase; 
          letter-spacing: 1px;
          color: #1a4d8c;
        }
        .fecha-gen { font-size: 11px; color: #888; margin-top: 5px; }
        
        /* Estadísticas */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 15px;
          margin-bottom: 30px;
        }
        .stat-card {
          border: 1px solid #eee;
          padding: 15px;
          border-radius: 10px;
          text-align: center;
          background: #fcfcfc;
        }
        .stat-label { font-size: 10px; font-weight: bold; color: #888; text-transform: uppercase; margin-bottom: 5px; }
        .stat-value { font-size: 18px; font-weight: 900; color: #333; }
        
        /* Tablas */
        .seccion-tabla { margin-bottom: 30px; }
        .seccion-tabla h2 { font-size: 14px; text-transform: uppercase; margin-bottom: 10px; border-left: 4px solid #1a4d8c; padding-left: 10px; }
        
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }
        th {
          background: #f4f4f4;
          padding: 10px;
          text-align: left;
          font-weight: bold;
          border-bottom: 2px solid #ddd;
        }
        td {
          padding: 8px 10px;
          border-bottom: 1px solid #eee;
        }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        
        /* Badges */
        .badge {
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 9px;
          font-weight: bold;
          text-transform: uppercase;
        }
        .badge-cashea { background: #e0f2f1; color: #00796b; border: 1px solid #b2dfdb; }
        .badge-empresa { background: #e8eaf6; color: #303f9f; border: 1px solid #c5cae9; }
        
        /* Footer */
        .footer {
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          text-align: center;
          font-size: 10px;
          color: #aaa;
        }
        
        @media print {
          .no-print { display: none; }
          body { padding: 0; }
          .stat-card { border: 1px solid #ddd; }
        }
      </style>
    </head>
    <body>
      <div class="reporte">
        <div class="header">
          <div class="logo-area">
            ${empresa.logoBase64 ? `<img src="${empresa.logoBase64}" class="logo-img" onerror="this.style.display='none'">` : ''}
            <div>
              <div class="empresa-nombre">${empresa.nombre}</div>
              <div class="empresa-slogan">${empresa.slogan}</div>
            </div>
          </div>
          <div class="rif-info">
            RIF: ${empresa.rif}<br>
            ${empresa.direccion}<br>
            ${empresa.ciudad}
          </div>
        </div>

        <div class="titulo-seccion">
          <h1>Reporte de Gestión de Créditos</h1>
          <p class="fecha-gen">Generado el: ${formatearFechaReporte(fechaActual.toISOString())}</p>
        </div>

        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-label">Total Pendiente</div>
            <div class="stat-value">${formatearMonedaUSD(estadisticas.totalPendiente)}</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">Deuda Cashea</div>
            <div class="stat-value" style="color: #00796b;">${formatearMonedaUSD(estadisticas.montoCashea)}</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">Deuda Empresa</div>
            <div class="stat-value" style="color: #303f9f;">${formatearMonedaUSD(estadisticas.montoEmpresa)}</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">Recuperación</div>
            <div class="stat-value">${estadisticas.porcentajeCobrado.toFixed(1)}%</div>
          </div>
        </div>

        <div class="seccion-tabla">
          <h2>Próximos Vencimientos</h2>
          <table>
            <thead>
              <tr>
                <th>Referencia</th>
                <th>Entidad</th>
                <th>Fecha</th>
                <th>Tipo</th>
                <th class="text-right">Monto Original</th>
                <th class="text-right">Saldo Pendiente</th>
              </tr>
            </thead>
            <tbody>
              ${estadisticas.proximosVencimientos.map(i => `
                <tr>
                  <td class="font-bold">#${i.referencia}</td>
                  <td>${i.entidad}</td>
                  <td>${formatearFechaCorta(i.fecha)}</td>
                  <td>
                    <span class="badge ${i.subTipo?.toLowerCase().includes('cashea') ? 'badge-cashea' : 'badge-empresa'}">
                      ${i.subTipo || 'EMPRESA'}
                    </span>
                  </td>
                  <td class="text-right">${formatearMonedaUSD(i.montoTotal)}</td>
                  <td class="text-right font-bold" style="color: #d32f2f;">${formatearMonedaUSD(i.saldo)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>

        <div class="footer">
          ${empresa.nombre} - Sistema de Gestión - Documento para uso interno
        </div>
      </div>

      <div class="no-print" style="position: fixed; bottom: 20px; right: 20px; display: flex; gap: 10px;">
        <button onclick="window.print()" style="padding: 10px 20px; background: #1a4d8c; color: white; border: none; border-radius: 5px; cursor: pointer; font-weight: bold;">
          🖨️ IMPRIMIR AHORA
        </button>
        <button onclick="window.close()" style="padding: 10px 20px; background: #eee; border: none; border-radius: 5px; cursor: pointer; font-weight: bold;">
          CERRAR
        </button>
      </div>
    </body>
    </html>
  `;
};

export const imprimirReporteCreditos = async (datos, estadisticas) => {
  try {
    const html = generarHTMLReporteCreditos(datos, estadisticas);
    const ventana = window.open('', '_blank', 'width=1000,height=800,menubar=yes,toolbar=yes');
    
    if (!ventana) {
      alert('Por favor permite las ventanas emergentes para imprimir el reporte.');
      return;
    }
    
    ventana.document.write(html);
    ventana.document.close();
    ventana.focus();
    
  } catch (error) {
    console.error('Error al generar el reporte de impresión:', error);
    alert('Hubo un error al generar el reporte.');
  }
};

// ============================================================
// REPORTE POR CLIENTE
// ============================================================

export const generarHTMLReportePorCliente = (resumenPorCliente) => {
  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant
  const fechaActual = new Date();
  
  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Reporte por Cliente - ${empresa.nombre}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: 'Arial', 'Helvetica', sans-serif;
          background: white;
          padding: 20px;
          color: #333;
        }
        .reporte { max-width: 1000px; margin: 0 auto; }
        
        /* Header */
        .header {
          padding: 15px 0;
          border-bottom: 2px solid #333;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .logo-area { display: flex; align-items: center; gap: 15px; }
        .logo-img { height: 60px; width: auto; object-fit: contain; }
        .empresa-nombre { font-size: 20px; font-weight: bold; color: #000; }
        .empresa-slogan { font-size: 12px; color: #666; }
        .rif-info { text-align: right; font-size: 11px; line-height: 1.4; color: #444; }
        
        /* Título */
        .titulo-seccion {
          margin-bottom: 25px;
          text-align: center;
        }
        .titulo-seccion h1 { 
          font-size: 22px; 
          text-transform: uppercase; 
          letter-spacing: 1px;
          color: #1a4d8c;
        }
        .fecha-gen { font-size: 11px; color: #888; margin-top: 5px; }
        
        /* Tablas */
        .seccion-tabla { margin-bottom: 30px; }
        
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
          margin-bottom: 20px;
        }
        th {
          background: #f4f4f4;
          padding: 10px;
          text-align: left;
          font-weight: bold;
          border-bottom: 2px solid #ddd;
        }
        td {
          padding: 8px 10px;
          border-bottom: 1px solid #eee;
        }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .cliente-row { background: #fcfcfc; font-size: 12px; }
        .detalle-row { background: #fff; }
        
        /* Footer */
        .footer {
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          text-align: center;
          font-size: 10px;
          color: #aaa;
        }
        
        @media print {
          .no-print { display: none; }
          body { padding: 0; }
        }
      </style>
    </head>
    <body>
      <div class="reporte">
        <div class="header">
          <div class="logo-area">
            ${empresa.logoBase64 ? `<img src="${empresa.logoBase64}" class="logo-img" onerror="this.style.display='none'">` : ''}
            <div>
              <div class="empresa-nombre">${empresa.nombre}</div>
              <div class="empresa-slogan">${empresa.slogan}</div>
            </div>
          </div>
          <div class="rif-info">
            RIF: ${empresa.rif}<br>
            ${empresa.direccion}<br>
            ${empresa.ciudad}
          </div>
        </div>

        <div class="titulo-seccion">
          <h1>Estado de Cuenta por Cliente</h1>
          <p class="fecha-gen">Generado el: ${formatearFechaReporte(fechaActual.toISOString())}</p>
        </div>

        <div class="seccion-tabla">
          ${resumenPorCliente.map(cliente => `
            <table style="border: 1px solid #ddd;">
              <thead>
                <tr class="cliente-row">
                  <th colspan="2" style="font-size: 14px;">CLIENTE: ${cliente.entidad}</th>
                  <th class="text-right">Ventas: ${formatearMonedaUSD(cliente.deudaVentas)}</th>
                  <th class="text-right">Reparaciones: ${formatearMonedaUSD(cliente.deudaReparaciones)}</th>
                  <th class="text-right" style="color: #d32f2f;">TOTAL: ${formatearMonedaUSD(cliente.totalDeuda)}</th>
                </tr>
                <tr style="font-size: 10px; background: #fafafa;">
                  <th>Referencia</th>
                  <th>Tipo</th>
                  <th>Fecha</th>
                  <th></th>
                  <th class="text-right">Saldo Pendiente</th>
                </tr>
              </thead>
              <tbody>
                ${cliente.detalles.map(d => `
                  <tr class="detalle-row">
                    <td class="font-bold">#${d.referencia}</td>
                    <td>${d.tipo} ${d.subTipo ? '(' + d.subTipo + ')' : ''}</td>
                    <td>${formatearFechaCorta(d.fecha)}</td>
                    <td></td>
                    <td class="text-right">${formatearMonedaUSD(d.saldo)}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          `).join('')}
        </div>

        <div class="footer">
          ${empresa.nombre} - Sistema de Gestión - Documento para uso interno
        </div>
      </div>

      <div class="no-print" style="position: fixed; bottom: 20px; right: 20px; display: flex; gap: 10px;">
        <button onclick="window.print()" style="padding: 10px 20px; background: #1a4d8c; color: white; border: none; border-radius: 5px; cursor: pointer; font-weight: bold;">
          🖨️ IMPRIMIR AHORA
        </button>
        <button onclick="window.close()" style="padding: 10px 20px; background: #eee; border: none; border-radius: 5px; cursor: pointer; font-weight: bold;">
          CERRAR
        </button>
      </div>
    </body>
    </html>
  `;
};

export const imprimirReportePorCliente = async (resumenPorCliente) => {
  try {
    const html = generarHTMLReportePorCliente(resumenPorCliente);
    const ventana = window.open('', '_blank', 'width=1000,height=800,menubar=yes,toolbar=yes');
    
    if (!ventana) {
      alert('Por favor permite las ventanas emergentes para imprimir el reporte.');
      return;
    }
    
    ventana.document.write(html);
    ventana.document.close();
    ventana.focus();
    
  } catch (error) {
    console.error('Error al generar el reporte de impresión:', error);
    alert('Hubo un error al generar el reporte.');
  }
};

// ============================================================
// EXPORT DEFAULT
// ============================================================
export default {
  generarHTMLReporteCreditos,
  imprimirReporteCreditos,
  generarHTMLReportePorCliente,
  imprimirReportePorCliente
};